(function() {
    window.announcementService = {
      get(data) {
        return axios.get(`/api/announcement/get.php`, data);
      },
      save(data) {
        return axios.post('/api/announcement/save.php', data);
      },
      getActiveAnnouncement(){
        return axios.post(`/api/announcement/get.php?active=true&&twitchId=${utils.cookies.get('user_id')}`);
      },
      announcementClosed() {
        twitchId = utils.cookies.get('user_id');
        return axios.post('/api/user/announcement/save.php', {});
      },
    }
  })();